export default __webpack_public_path__ + "static/media/For developers Image (1).f4b8a2d2.svg";